import { GAIdClient } from "commonModule/services/client"
import { defaultAxiosInstance } from "services/client"

export const apiGAIdClient = new GAIdClient(defaultAxiosInstance)
